import styled from "styled-components";
import { useRef } from "react";
import generatePDF from "react-to-pdf";
import { TheDate } from "../../../constants/thedate";

export function KgResult(props) {
  const resultRef = useRef();
  if (!props.owner) return null;

  const getClass = (user) => {
    switch (props.historicalClass || user?.currentClass) {
      case "FGJSC_001":
        return "JSS 1";
      case "FGJSC_002":
        return "JSS 2";
      case "FGJSC_003":
        return "JSS 3";
      case "FGSSC_001":
        return "SSS 1";
      case "FGSSC_002":
        return "SSS 2";
      case "FGSSC_003":
        return "SSS 3";
      case "FGBSC_001":
        return "Basic 1";
      case "FGBSC_002":
        return "Basic 2";
      case "FGBSC_003":
        return "Basic 3";
      case "FGBSC_004":
        return "Basic 4";
      case "FGBSC_005":
        return "Basic 5";
      case "FGKGC_001":
        return "K.G 1";
      case "FGKGC_002":
        return "K.G 2";
      case "FGNSC_001":
        return "Nursery 1";
      case "FGNSC_002":
        return "Nursery 2";
      default:
        return "None";
    }
  };

  const renderTick = (val, expected) => {
    if (!val) return "";
    const normalizedVal = String(val).trim().toLowerCase().replace("-", "");
    const normalizedExpected = expected.toLowerCase().replace("-", "");
    return normalizedVal === normalizedExpected ? "✓" : "";
  };

  const r = props.results || [];

  return (
    <div className="d-flex flex-column gap-5">
      <div className="download-field d-flex flex-row px-5">
        <button
          onClick={() =>
            generatePDF(resultRef, {
              filename:
                props.owner.firstName + props.owner.admissionNumber + "-KG",
            })
          }
        >
          download
        </button>
      </div>

      <ResultDiv className="d-flex flex-column gap-1 p-3 pb-0" ref={resultRef}>
        {/* Header */}
        <img src="/images/junior-header.jpg" className="logo-container" />

        {/* Student Info Row 1 */}
        <div className="d-flex flex-row intro-header mt-1 align-items-center justify-content-between p-2">
          <div className="title">
            <p>Academic Year</p>
            <p className="academic-year">
              {props.session}/{Number(props.session) + 1}
            </p>
          </div>
          <div>
            <h6>{props.term} TERM RESULT</h6>
          </div>
          <div className="title">
            <p>Admission Number</p>
            <p className="academic-year">{props.owner.admissionNumber}</p>
          </div>
        </div>

        {/* Student Info Row 2 */}
        <div className="d-flex flex-row intro-header align-items-center justify-content-between p-2">
          <div className="title w-75 d-flex flex-row">
            <p style={{ width: "10%" }}>Name</p>
            <p className="student-name" style={{ width: "80%" }}>
              {props.owner.lastName} {props.owner.firstName}{" "}
              {props.owner.middleName}
            </p>
          </div>
          <div className="title w-25 d-flex flex-row">
            <p style={{ width: "30%" }}>Class</p>
            <p className="student-name" style={{ width: "50%" }}>
              {/* {getClass(props.owner)} */}
              Preschool
            </p>
          </div>
        </div>

        {/* Two-column layout: Subjects table + Activities table */}
        <div className="d-flex flex-column tables-wrapper w-full gap-3">
          {/* LEFT: Performance in Subjects */}
          <div className="subjects-col w-full">
            <div className="section-header">PERFORMANCE IN SUBJECTS</div>
            <table className="table mb-0" border="1" width="100%">
              <thead>
                <tr>
                  <th>SUBJECTS</th>
                  <th>REMARKS</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>LETTER WORK</td>
                  <td className="text-center">{r[6]}</td>
                </tr>
                <tr>
                  <td>NUMBER WORK</td>
                  <td className="text-center">{r[7]}</td>
                </tr>
                <tr>
                  <td>DEEN</td>
                  <td className="text-center">{r[8]}</td>
                </tr>
                <tr>
                  <td>ARABIC</td>
                  <td className="text-center">{r[9]}</td>
                </tr>
                <tr>
                  <td>QURA'AN AND HADITH</td>
                  <td className="text-center">{r[10]}</td>
                </tr>
                <tr>
                  <td>HANDWRITING</td>
                  <td className="text-center">{r[11]}</td>
                </tr>
                <tr>
                  <td>FINE ART</td>
                  <td className="text-center">{r[12]}</td>
                </tr>
                <tr>
                  <td>PHYSICAL AND HEALTH EDU.</td>
                  <td className="text-center">{r[13]}</td>
                </tr>
                <tr>
                  <td>SOCIAL NORM</td>
                  <td className="text-center">{r[14]}</td>
                </tr>
                <tr>
                  <td>COMPUTER</td>
                  <td className="text-center">{r[15]}</td>
                </tr>
                <tr>
                  <td>PRACTICAL LIFE</td>
                  <td className="text-center">{r[16]}</td>
                </tr>
                <tr>
                  <td>NATURE STUDY</td>
                  <td className="text-center">{r[17]}</td>
                </tr>
                <tr>
                  <td>RHYME</td>
                  <td className="text-center">{r[18]}</td>
                </tr>
                <tr className="average-row">
                  <td>
                    <strong style={{ color: "red" }}>AVERAGE RATING</strong>
                  </td>
                  <td className="text-center">
                    <strong style={{ color: "red" }}>{r[4]}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="rating-scale">
              Rating Scale: <strong>A</strong> – Excellent (85–100)
              &nbsp;•&nbsp;
              <strong>B</strong> – Very Good (70–84) &nbsp;•&nbsp;
              <strong>C</strong> – Good (55–69) &nbsp;•&nbsp;
              <strong>D</strong> – Fair (40–54) &nbsp;•&nbsp;
              <strong>E</strong> – Poor (&lt;40)
            </div>
          </div>

          {/* RIGHT: Activities Ratings */}
          <div className="activities-col w-full">
            <div className="section-header">ACTIVITIES RATINGS</div>
            <table
              className="table table-bordered mb-0"
              border="1"
              width="100%"
            >
              <thead>
                <tr>
                  <th className="item-col">Categories / Items</th>
                  <th>Always</th>
                  <th>Some-times</th>
                  <th>Never</th>
                  <th>Not Observed</th>
                </tr>
              </thead>
              <tbody>
                {/* Creative Arts */}
                <tr className="category-row">
                  <td colSpan={5}>Creative Arts</td>
                </tr>
                <tr>
                  <td>He/She is able to scribble</td>
                  <td className="text-center">{renderTick(r[19], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[19], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[19], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[19], "Not Observed")}
                  </td>
                </tr>
                <tr>
                  <td>He/She is able to draw / paint</td>
                  <td className="text-center">{renderTick(r[20], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[20], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[20], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[20], "Not Observed")}
                  </td>
                </tr>
                {/* Social Norms */}
                <tr className="category-row">
                  <td colSpan={5}>Social Norms</td>
                </tr>
                <tr>
                  <td>He/She is able to adjust to social habits</td>
                  <td className="text-center">{renderTick(r[21], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[21], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[21], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[21], "Not Observed")}
                  </td>
                </tr>
                <tr>
                  <td>He/She is able to interact / exchange materials</td>
                  <td className="text-center">{renderTick(r[22], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[22], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[22], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[22], "Not Observed")}
                  </td>
                </tr>
                <tr>
                  <td>He/She is able to obey simple instructions</td>
                  <td className="text-center">{renderTick(r[23], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[23], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[23], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[23], "Not Observed")}
                  </td>
                </tr>
                {/* Physical & Health Education */}
                <tr className="category-row">
                  <td colSpan={5}>Physical &amp; Health Education (Games)</td>
                </tr>
                <tr>
                  <td>He/She is able to sing some health songs</td>
                  <td className="text-center">{renderTick(r[24], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[24], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[24], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[24], "Not Observed")}
                  </td>
                </tr>
                <tr>
                  <td>He/She is able to take part in simple games</td>
                  <td className="text-center">{renderTick(r[25], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[25], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[25], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[25], "Not Observed")}
                  </td>
                </tr>
                {/* Language & Communication */}
                <tr className="category-row">
                  <td colSpan={5}>Language and Communication Skills</td>
                </tr>
                <tr>
                  <td>He/She is able to communicate with others</td>
                  <td className="text-center">{renderTick(r[26], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[26], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[26], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[26], "Not Observed")}
                  </td>
                </tr>
                <tr>
                  <td>He/She is able to recite rhymes &amp; sing songs</td>
                  <td className="text-center">{renderTick(r[27], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[27], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[27], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[27], "Not Observed")}
                  </td>
                </tr>
                <tr>
                  <td>He/She is able to identify colours and objects</td>
                  <td className="text-center">{renderTick(r[28], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[28], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[28], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[28], "Not Observed")}
                  </td>
                </tr>
                {/* Number Work Skill */}
                <tr className="category-row">
                  <td colSpan={5}>Number Work Skill</td>
                </tr>
                <tr>
                  <td>He/She is able to differentiate colours and shapes</td>
                  <td className="text-center">{renderTick(r[29], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[29], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[29], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[29], "Not Observed")}
                  </td>
                </tr>
                <tr>
                  <td>He/She is able to identify number symbols 1–20</td>
                  <td className="text-center">{renderTick(r[30], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[30], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[30], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[30], "Not Observed")}
                  </td>
                </tr>
                {/* Scientific & Reflective Thinking */}
                <tr className="category-row">
                  <td colSpan={5}>Scientific and Reflective Thinking</td>
                </tr>
                <tr>
                  <td>He/She is able to distinguish flowers and leaves</td>
                  <td className="text-center">{renderTick(r[31], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[31], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[31], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[31], "Not Observed")}
                  </td>
                </tr>
                <tr>
                  <td>He/She is able to identify pictures of animals</td>
                  <td className="text-center">{renderTick(r[32], "Always")}</td>
                  <td className="text-center">
                    {renderTick(r[32], "Sometimes")}
                  </td>
                  <td className="text-center">{renderTick(r[32], "Never")}</td>
                  <td className="text-center">
                    {renderTick(r[32], "Not Observed")}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Comments & Stamp Section */}
        <div className="comments-section d-flex flex-column px-1">
          <div className="comment-line">
            <p className="comment-label">Class Teacher's Comments:</p>
            <p className="comments comment-value">{r[1]}</p>
          </div>
          <div className="comment-line">
            <p className="comment-label">Signature / Date:</p>
            <p className="comments comment-value">{props.datePublished}</p>
          </div>
          <div className="comment-line">
            <p className="comment-label">Head Teacher's / Master's Comments:</p>
            <p className="comments comment-value">{r[2]}</p>
          </div>
          <div className="comment-line">
            <p className="comment-label">General Comments:</p>
            <p className="comments comment-value">{r[3]}</p>
          </div>
          <div className="d-flex flex-row justify-content-between align-items-end">
            {/* <div className="comment-line" style={{ width: "60%" }}>
              <p className="comment-label">
                Signature &amp; Date / School Stamp:
              </p>
              <p className="comments comment-value"></p>
            </div> */}
            <div className="comment-line" style={{ width: "35%" }}>
              <p className="comment-label">School Reopens:</p>
              <p className="comments comment-value">{r[5]}</p>
            </div>
            <div className="stamp-img kg-stamp">
              <img src="/images/furdaus-stamp.jpg" />
            </div>
          </div>
        </div>
      </ResultDiv>
    </div>
  );
}

const ResultDiv = styled.div`
  width: 970px;
  margin: auto;
  background-color: white;
  font-weight: 400;

  p {
    width: fit-content !important;
  }
  p,
  h3,
  h6 {
    margin: 0 !important;
  }

  .logo-container {
    height: 180px;
    // width: 100% !important;
    object-fit: cover !important;
  }

  .intro-header {
    border: 1px solid black;
    height: 42px;
    font-size: 12px;
  }
  .academic-year {
    font-weight: 600 !important;
  }
  .student-name {
    border-bottom: 1px solid black;
  }
  h6 {
    font-weight: 600 !important;
    font-size: 12px !important;
  }

  .instruction {
    font-size: 10px;
    color: #444;
    margin: 2px 0 !important;
    width: 100% !important;
  }

  /* Two-column layout */
  .tables-wrapper {
    gap: 0;
    border: 1px solid black;
  }
  .subjects-col {
    border-right: 1px solid black;
    display: flex;
    flex-direction: column;
  }
  .activities-col {
    display: flex;
    flex-direction: column;
  }
  .section-header {
    color: black;
    text-align: center;
    font-weight: 600;
    font-size: 11px;
    padding: 3px 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .table {
    border-collapse: collapse !important;
    border: 0 !important;
  }
  td {
    border: 1px solid black;
    border-collapse: collapse !important;
    font-size: 10px;
    padding: 2px 3px !important;
  }
  th {
    font-weight: 600;
    text-align: center;
    font-size: 10px;
    border: 1px solid black !important;
    padding: 2px 3px !important;
    background-color: #f0f0f0;
  }
  .item-col {
    text-align: left;
    width: 55%;
  }
  .average-row td {
    background-color: #f5f5f5;
  }
  .category-row td {
    background-color: #e8e8e8;
    font-weight: 600;
    font-size: 11px;
    padding: 2px 4px !important;
  }

  .rating-scale {
    font-size: 9px;
    padding: 3px 4px;
    border: 1px solid black;
    border-top: 0;
    background-color: #fafafa;
    line-height: 1.3;
  }

  /* Comments section */
  .comments-section {
    margin-top: 4px;
    gap: 2px;
  }
  .comment-line {
    display: block;
    border-bottom: 1px solid #ccc;
    padding-bottom: 2px;
    margin-bottom: 2px;
  }
  .comment-label {
    font-size: 10px;
    color: #555;
  }
  .comment-value {
    font-size: 11px;
    font-weight: 600;
    min-height: 14px;
  }
  .comments {
    font-weight: 600;
  }


  @media print {
    width: 100%;
    .logo-container {
      height: 130px;
    }
    td,
    th,
    p,
    h6 {
      font-size: 9px !important;
      padding: 1px 2px !important;
    }
    .intro-header {
      height: 28px;
    }
  }
`;
